export const lastTransactionCode = {
    "curl": {
      "request": `curl -X 'POST'
'https://demo-api.westpay.se/in-store/api/v1/terminal/80000782/lastTransaction'
-H 'accept: text/plain'
-H 'Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04'
-H 'Ocp-Apim-Subscription-Key: 76591d32138f4f60b580db9ec9167f1d'
-d ''`
    },
    "java": {
      "request": `import java.net.URI;
import java.net.http.HttpClient;
import java.net.http.HttpRequest;
import java.net.http.HttpResponse;
import java.net.http.HttpHeaders;
      
public class LastTransactionExample {
    public static void main(String[] args) {
        String url = "https://demo-api.westpay.se/in-store/api/v1/terminal/80000782/lastTransaction";
        String authorization = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04";
        String ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";
      
        try {
            HttpClient client = HttpClient.newHttpClient();
            HttpRequest request = HttpRequest.newBuilder()
                    .uri(URI.create(url))
                    .header("accept", "text/plain")
                    .header("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey)
                    .header("Authorization", authorization)
                    .POST(HttpRequest.BodyPublishers.noBody())
                    .build();
      
            HttpResponse<String> response = client.send(request, HttpResponse.BodyHandlers.ofString());
            int statusCode = response.statusCode();
            String responseBody = response.body();
            HttpHeaders headers = response.headers();
      
            System.out.println("Response Code: " + statusCode);
            System.out.println("Response Body: " + responseBody);
        } catch (Exception e) {
            e.printStackTrace();
        }
    }
}`
    },
    "C#": {
      "request": `using System;
using System.Net.Http;
using System.Threading.Tasks;
      
class LastTransactionExample
{
    static async Task Main()
    {
        string url = "https://demo-api.westpay.se/in-store/api/v1/terminal/80000782/lastTransaction";
        string authorization = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04";
        string ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";
      
        HttpClient httpClient = new HttpClient();
      
        httpClient.DefaultRequestHeaders.Add("accept", "text/plain");
        httpClient.DefaultRequestHeaders.Add("Authorization", authorization);
        httpClient.DefaultRequestHeaders.Add("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey);
      
        HttpResponseMessage response = await httpClient.PostAsync(url, null);
      
        if (response.IsSuccessStatusCode)
        {
            string responseBody = await response.Content.ReadAsStringAsync();
            Console.WriteLine("Response Code: " + (int)response.StatusCode);
            Console.WriteLine("Response Body: " + responseBody);
        }
        else
        {
            Console.WriteLine("Request failed. Response Code: " + (int)response.StatusCode);
        }
    }
}`
    },
    "python": {
      "request": `import requests

url = "https://demo-api.westpay.se/in-store/api/v1/terminal/80000782/lastTransaction"
authorization = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04"
ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d"
      
headers = {
    "accept": "text/plain",
    "Authorization": authorization,
    "Ocp-Apim-Subscription-Key": ocpApimSubscriptionKey
}
      
response = requests.post(url, headers=headers)
      
if response.status_code == 201:
    print("Response Code:", response.status_code)
    print("Response Body:", response.text)
else:
    print("Request failed. Response Code:", response.status_code)`
    },
    
    "JavaScript": {
      "request": `const fetch = require('node-fetch');

const url = 'https://demo-api.westpay.se/in-store/api/v1/terminal/80000782/lastTransaction';
const authorization = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ik1lcmNoYW50IDI5MDAwODAxNyIsInJvbGUiOiJNZXJjaGFudCIsIm5iZiI6MTY4MjQ0NDU5MSwiZXhwIjoxNzEzOTgwNTkxLCJpYXQiOjE2ODI0NDQ1OTEsImlzcyI6Ildlc3RwYXkgQUIiLCJhdWQiOiIyOTAwMDgwMTcifQ.UJbmmah_5rOkmbjNtENjaXJusiayub7-3WqaQgdLg04';
const ocpApimSubscriptionKey = '76591d32138f4f60b580db9ec9167f1d';
      
const headers = {
  'accept': 'text/plain',
  'Authorization': authorization,
  'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey
};
      
fetch(url, {
  method: 'POST',
  headers: headers
})
  .then(response => {
    if (response.status === 201) {
      return response.text();
    } else {
      throw new Error('Request failed. Response code: ' + response.status);
    }
  })
  .then(responseBody => {
    console.log('Response Body:', responseBody);
  })
  .catch(error => {
    console.error(error);
  });`
    }
  };
  
export const lastTransactionCodeResponse = `{
    "onlineAPIRefId": "23179050000964"
}`;
  